import { inject } from '@angular/core';
import { LocalStorageService } from '../local-storage.service';
import { Router } from '@angular/router';

export const notLogedInGuardInjectable = () => {

    const localStorageService: LocalStorageService = inject(LocalStorageService);
    const router: Router = inject(Router);

    // check if user is loged in or not by using localstorageService
    // get the session
    let session = localStorageService.getSession();

    // if session is null user is not loged in
    if(!session) {
        // user not loged in stay where you are
        return true;
    }else {
        // user is loged in go to home page
        return router.navigate(['/home']);
    }

}



export const notLogedInGuardInjectableAlt = () => {


    return true;

}
